import { useGetUserQuery } from '@/store/api/userApi'
import { useMsal } from '@azure/msal-react'
import { skipToken } from '@reduxjs/toolkit/query'

export const useUser = () => {
  const { instance } = useMsal()
  const activeAccount = instance.getActiveAccount()
  const userId = activeAccount?.localAccountId
  return useGetUserQuery(userId ?? skipToken)
}
